import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from '../../../../../config/Translate';
import validator from 'validator';
import axios from 'axios';
import { defaultVariabls } from '../../../../../config/index';
import { withRouter} from "react-router";
import {withSnackbar} from "notistack";
import LoadingButton from "../../../../components/elements/LoadingButton";
import {connect, setStore} from "trim-redux";
import AppCardLoaderFields from "../../../../components/Skeletons/AppCardLoaderFields";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import ChooseDate from "../../../../components/elements/ChooseDate";
import SubTitleLight from "../../../../components/elements/SubTitleLight";
import Button from "@material-ui/core/Button/Button";
import ProposalSubmissionButton from "./buttons/ProposalSubmissionButton";
import ProposalReadButton from "./buttons/ProposalReadButton";
import PaymentAnnouncementButton from "./buttons/paymentAnnouncementButton";
import PaymentDidNotPayedButton from "./buttons/paymentDidNotPayedButton";
import MeetingAnnouncementButton from "./buttons/MeetingAnnouncementButton";
import MeetingLinkButton from "./buttons/MeetingLinkButton";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox/Checkbox";

class MakePerson extends React.Component {
    classes = this.props.classes
    state={
        fields: {
            name: '',
            nickname: '',
            mobile:'',
            gender:'male',
            how_to_connect:'',
            how_to_acquisition:'',
            project_type:'',
            status:'pending_for_call',
            first_impression_at:null,
            description:"",
            type:'person',
            melli_code:'',
            address:'',
            email:'',
            birth_date:null,
            father_name:'',
            phone_number:"",
            postal_code:'',
            company_name:'',
            company_national_code:'',
            company_register_number:'',
            company_financial_number:'',
            company_ceo:'',
            company_ceo_mobile:'',
        },
        errors:{},
        loading:true,
        contract_info_done:0,
        has_invoice:0,
        person:null,
        SubmitLoading:false,
        id:this.props.match.params.id,
    };
    componentDidMount() {
        if(!!this.props.new){
            this.setState({
                loading:false,
            })
        }else{
            this.loadData();
        }
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        let {id} = this.state;
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/person/get/${id}`, config)
                .then(response => {
                    this.setState({
                        fields: {
                            nickname: !!response.data.nickname ? response.data.nickname : "",
                            gender:!!response.data.gender ? response.data.gender : "",
                            project_type:!!response.data.project_type ? response.data.project_type : "",
                            how_to_connect:!!response.data.how_to_connect ? response.data.how_to_connect : "",
                            how_to_acquisition:!!response.data.how_to_acquisition ? response.data.how_to_acquisition : "",
                            status:!!response.data.status ? response.data.status : "",
                            first_impression_at:!!response.data.first_impression_at ? response.data.first_impression_at : null,
                            description:!!response.data.description ? response.data.description : "",
                            father_name:!!response.data.father_name ? response.data.father_name : "",
                            name: !!response.data.name ? response.data.name : '',
                            mobile:!!response.data.mobile ? response.data.mobile : '',
                            type:!!response.data.type ? response.data.type : '',
                            melli_code:!!response.data.melli_code ? response.data.melli_code : '',
                            address:!!response.data.address ? response.data.address : '',
                            email:!!response.data.email ? response.data.email :'',
                            birth_date:!!response.data.birth_date ? response.data.birth_date : '',
                            phone_number:!!response.data.phone_number ? response.data.phone_number : '',
                            postal_code:!!response.data.postal_code ? response.data.postal_code : '',
                            company_name:!!response.data.company_name ? response.data.company_name : '',
                            company_national_code:!!response.data.company_national_code ? response.data.company_national_code :'',
                            company_register_number:!!response.data.company_register_number ? response.data.company_register_number : '',
                            company_financial_number:!!response.data.company_financial_number ? response.data.company_financial_number : '',
                            company_ceo:!!response.data.company_ceo ? response.data.company_ceo :'',
                            company_ceo_mobile:!!response.data.company_ceo_mobile ? response.data.company_ceo_mobile : '',
                        },
                        person:response.data,
                        contract_info_done:response.data.contract_info_done,
                        has_invoice:response.data.has_invoice,
                        loading:false
                    })
                }).catch(error => {
                    console.log(error.response)
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
            this.setState({
                loading:false
            })
        }
    }
    handleChange(e){
        let {fields,errors} = this.state;
        let target = e.target;
        errors[target.name] = "";
        fields[target.name] = target.value;
        this.setState({
            fields,

        });
    }
    handleValidation(callback){
        let { fields } = this.state;
        let errors = {};
        let formIsValid = true;
        //mobile
        if(validator.isEmpty(fields.mobile)){
            formIsValid = false;
            errors['mobile'] = Translate.emptyMobile;
        }

        if(!formIsValid){
            this.props.enqueueSnackbar(Translate.someFieldsHasError, {
                variant: 'warning',
            });
            this.setState({
                SubmitLoading:false
            })
        }
        return callback(formIsValid)
    }
    handleRequest(){
        const {fields,id,contract_info_done,has_invoice} = this.state;
        let data = new FormData();
        data.append('name', fields.name);
        data.append('nickname', fields.nickname);
        data.append('mobile', fields.mobile);
        data.append('gender', fields.gender);
        data.append('project_type', fields.project_type);
        data.append('how_to_acquisition', fields.how_to_acquisition);
        data.append('how_to_connect', fields.how_to_connect);
        data.append('status', fields.status);
        data.append('first_impression_at', fields.first_impression_at);
        data.append('description', fields.description);
        data.append('type', fields.type);
        data.append('melli_code', fields.melli_code);
        data.append('address', fields.address);
        data.append('email', fields.email);
        data.append('birth_date', fields.birth_date);
        data.append('father_name', fields.father_name);
        data.append('phone_number', fields.phone_number);
        data.append('postal_code', fields.postal_code);
        data.append('company_name', fields.company_name);
        data.append('company_national_code', fields.company_national_code);
        data.append('company_national_code', fields.company_national_code);
        data.append('company_register_number', fields.company_register_number);
        data.append('company_financial_number', fields.company_financial_number);
        data.append('company_ceo', fields.company_ceo);
        data.append('company_ceo_mobile', fields.company_ceo_mobile);
        data.append('contract_info_done',!!contract_info_done ? 1 : 0);
        data.append('has_invoice',!!has_invoice ? 1 : 0);
        if(!this.props.new){
            data.append('id', id);
        }
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/person/make`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.detailsSet, {
                    variant: 'success',
                });
                this.setState({
                    SubmitLoading:false
                });
                if(!!this.props.new){
                    this.props.history.push(`/manage/people/view/all`);
                }else{
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    })
                }
            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(Translate.detailsSetFailed, {
                    variant: 'error',
                });
            });
    }
    handleSubmit(e){
        this.setState({
            SubmitLoading:true
        });
        e.preventDefault();
        this.handleValidation((valid) =>{
            if(valid) {
                this.handleRequest();
            }

        });
    }
    handleItem(item,val){
        let {fields} = this.state;
        fields[item] = val;
        this.setState({
            fields,
        })

    }
    handleCopyReviewLink(){
        let {person} = this.state;
        let link = `${defaultVariabls.React}/rev/${person.unique_id}`;
        navigator.clipboard.writeText(link);
        this.props.enqueueSnackbar(Translate.linkCopied, {
            variant: 'info',
        });
    }
    handleCopyInfoLink(){
        let {person} = this.state;
        let link = `${defaultVariabls.React}/det/${person.unique_id}`;
        navigator.clipboard.writeText(link);
        this.props.enqueueSnackbar(Translate.linkCopied, {
            variant: 'info',
        });
    }
    render() {
        const {errors,fields,SubmitLoading,id,person,contract_info_done,has_invoice} = this.state;
        if (this.state.loading) {
            return (
                <AppCardLoaderFields/>
            )
        } else {
            return (
                <React.Fragment>
                    <Grid container  spacing={2} justify="center" alignItems="center">
                        <CssBaseline/>
                        {
                            !this.props.new &&
                            <>
                                <Grid item xs={12}>
                                    <SubTitleLight align="left">
                                        {Translate.managingActions}
                                    </SubTitleLight>
                                </Grid>
                                <Grid item xs={12} style={{background:"rgb(251 251 251)",marginBottom:20,borderRadius:6,padding:20}}>
                                    <SubTitleLight align="left">
                                        {fields.name} {!!fields.nickname ? "("+fields.nickname+")" : null}
                                    </SubTitleLight>
                                    <Button
                                        size="small"
                                        color="primary"
                                        variant="outlined"
                                        style={{marginLeft:5,marginRight:5}}
                                        onClick={() => this.handleCopyInfoLink()}
                                    >
                                        {Translate.copyInfoLink}
                                    </Button>
                                    <ProposalReadButton person={person}/>
                                    <ProposalSubmissionButton person={person}/>
                                    <PaymentAnnouncementButton person={person} />
                                    <PaymentDidNotPayedButton person={person} />
                                    <MeetingAnnouncementButton person={person} />
                                    <MeetingLinkButton person={person} />
                                    <Button
                                        size="small"
                                        color="primary"
                                        variant="outlined"
                                        style={{marginLeft:5,marginRight:5}}
                                        onClick={() => this.handleCopyReviewLink()}
                                    >
                                        {Translate.copyReviewLink}
                                    </Button>
                                </Grid>
                            </>
                        }
                        <Grid item xs={12}>
                            <SubTitleLight align="left">
                                {Translate.managingInfo}
                            </SubTitleLight>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                variant="outlined"
                                value={fields.gender}
                                size="small"
                                fullWidth
                                label={Translate.gender}
                                name="gender"
                                onChange={this.handleChange.bind(this)}
                                error = {!!errors['gender']}
                                helperText={errors['gender']}
                                select
                            >
                                <MenuItem value={"female"}>
                                    {Translate.female}
                                </MenuItem>
                                <MenuItem value={"male"}>
                                    {Translate.male}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                variant="outlined"
                                value={fields.name}
                                fullWidth
                                size="small"
                                label={Translate.personName}
                                name="name"
                                onChange={this.handleChange.bind(this)}
                                error = {!!errors['name']}
                                helperText={errors['name']}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                variant="outlined"
                                required
                                value={fields.mobile}
                                fullWidth
                                label={Translate.mobile}
                                name="mobile"
                                size="small"
                                onChange={this.handleChange.bind(this)}
                                error = {!!errors['mobile']}
                                helperText={errors['mobile']}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                variant="outlined"
                                value={fields.nickname}
                                fullWidth
                                size="small"
                                label={Translate.nickname}
                                placeholder={Translate.nicknameDesc}
                                name="nickname"
                                onChange={this.handleChange.bind(this)}
                                error = {!!errors['nickname']}
                                helperText={errors['nickname']}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                variant="outlined"
                                value={fields.how_to_acquisition}
                                size="small"
                                fullWidth
                                label={Translate.how_to_acquisition}
                                name="how_to_acquisition"
                                onChange={this.handleChange.bind(this)}
                                error = {!!errors['how_to_acquisition']}
                                helperText={errors['how_to_acquisition']}
                                select
                            >
                                <MenuItem value={"سئو"}>
                                    سئو
                                </MenuItem>
                                <MenuItem value={"گوگل ادز"}>
                                    گوگل ادز
                                </MenuItem>
                                <MenuItem value={"آشنایان"}>
                                    آشنایان
                                </MenuItem>
                                <MenuItem value={"سایر"}>
                                    سایر
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                variant="outlined"
                                value={fields.how_to_connect}
                                size="small"
                                fullWidth
                                label={Translate.how_to_connect}
                                name="how_to_connect"
                                onChange={this.handleChange.bind(this)}
                                error = {!!errors['how_to_connect']}
                                helperText={errors['how_to_connect']}
                                select
                            >
                                <MenuItem value={"تماس"}>
                                    تماس
                                </MenuItem>
                                <MenuItem value={"فرم درخواست مشاوره"}>
                                    فرم درخواست مشاوره
                                </MenuItem>
                                <MenuItem value={"فرم استعلام قیمت"}>
                                    فرم استعلام قیمت
                                </MenuItem>
                                <MenuItem value={"واتس اپ"}>
                                    واتس اپ
                                </MenuItem>
                                <MenuItem value={"چت آنلاین"}>
                                    چت آنلاین
                                </MenuItem>
                                <MenuItem value={"تلگرام"}>
                                    تلگرام
                                </MenuItem>
                                <MenuItem value={"فرم تماس با ما"}>
                                    فرم تماس با ما
                                </MenuItem>
                                <MenuItem value={"ایمیل"}>
                                    ایمیل
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                variant="outlined"
                                value={fields.project_type}
                                size="small"
                                fullWidth
                                label={Translate.project_type}
                                name="project_type"
                                onChange={this.handleChange.bind(this)}
                                error = {!!errors['project_type']}
                                helperText={errors['project_type']}
                                select
                            >
                                <MenuItem value={"شرکتی وردپرسی"}>
                                    شرکتی وردپرسی
                                </MenuItem>
                                <MenuItem value={"فروشگاه وردپرسی"}>
                                    فروشگاه وردپرسی
                                </MenuItem>
                                <MenuItem value={"آموزشی وردپرسی"}>
                                    آموزشی وردپرسی
                                </MenuItem>
                                <MenuItem value={"خبری وردپرسی"}>
                                    خبری وردپرسی
                                </MenuItem>
                                <MenuItem value={"چندفروشندگی وردپرسی"}>
                                    چندفروشندگی وردپرسی
                                </MenuItem>
                                <MenuItem value={"اختصاصی"}>
                                    اختصاصی
                                </MenuItem>
                                <MenuItem value={"اتوماسیون"}>
                                    اتوماسیون
                                </MenuItem>
                                <MenuItem value={"مارکت پلیس"}>
                                    مارکت پلیس
                                </MenuItem>
                                <MenuItem value={"سئو"}>
                                    سئو
                                </MenuItem>
                                <MenuItem value={"اپلیکیشن"}>
                                    اپلیکیشن
                                </MenuItem>
                                <MenuItem value={"دیجیتال مارکتینگ"}>
                                    دیجیتال مارکتینگ
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <ChooseDate
                                input={fields.first_impression_at}
                                noMargin
                                handleDate={(val) => this.handleItem('first_impression_at',val)}
                                label={Translate.first_impression}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                variant="outlined"
                                size="small"
                                value={fields.status}
                                fullWidth
                                label={Translate.status}
                                name="status"
                                onChange={this.handleChange.bind(this)}
                                error = {!!errors['status']}
                                helperText={errors['status']}
                                select
                            >
                                <MenuItem value={"pending_for_call"}>
                                    {Translate.pending_for_call}
                                </MenuItem>
                                <MenuItem value={"not_answered"}>
                                    {Translate.not_answered}
                                </MenuItem>
                                <MenuItem value={"end"}>
                                    {Translate.end}
                                </MenuItem>
                                <MenuItem value={"bad_customer"}>
                                    {Translate.bad_customer}
                                </MenuItem>
                                <MenuItem value={"maybe"}>
                                    {Translate.maybe}
                                </MenuItem>
                                <MenuItem value={"contract"}>
                                    {Translate.contract}
                                </MenuItem>
                                <MenuItem value={"done"}>
                                    {Translate.done}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                value={fields.description}
                                fullWidth
                                size="small"
                                multiline
                                minRows={2}
                                label={Translate.personDescription}
                                name="description"
                                onChange={this.handleChange.bind(this)}
                                error = {!!errors['description']}
                                helperText={errors['description']}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <SubTitleLight align="left">
                                {Translate.personalInfo}
                            </SubTitleLight>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                variant="outlined"
                                size="small"
                                value={fields.type}
                                fullWidth
                                label={Translate.businessType}
                                name="type"
                                onChange={this.handleChange.bind(this)}
                                error = {!!errors['type']}
                                helperText={errors['type']}
                                select
                            >
                                <MenuItem value={"person"}>
                                    {Translate.person}
                                </MenuItem>
                                <MenuItem value={"company"}>
                                    {Translate.company}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                variant="outlined"
                                size="small"
                                value={fields.company_ceo}
                                fullWidth
                                label={fields.type === "company" ?  Translate.company_ceo : Translate.userName}
                                name="company_ceo"
                                onChange={this.handleChange.bind(this)}
                                error = {!!errors['company_ceo']}
                                helperText={errors['company_ceo']}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                variant="outlined"
                                value={fields.company_ceo_mobile}
                                size="small"
                                fullWidth
                                label={fields.type === "company" ?  Translate.company_ceo_mobile : Translate.mobile}
                                name="company_ceo_mobile"
                                onChange={this.handleChange.bind(this)}
                                error = {!!errors['company_ceo_mobile']}
                                helperText={errors['company_ceo_mobile']}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                variant="outlined"
                                value={fields.melli_code}
                                fullWidth
                                size="small"
                                label={Translate.melli_code}
                                name="melli_code"
                                onChange={this.handleChange.bind(this)}
                                error = {!!errors['melli_code']}
                                helperText={errors['melli_code']}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                variant="outlined"
                                value={fields.email}
                                fullWidth
                                type="email"
                                label={Translate.email}
                                size="small"
                                name="email"
                                onChange={this.handleChange.bind(this)}
                                error = {!!errors['email']}
                                helperText={errors['email']}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                variant="outlined"
                                value={fields.father_name}
                                fullWidth
                                size="small"
                                label={Translate.father_name}
                                name="father_name"
                                onChange={this.handleChange.bind(this)}
                                error = {!!errors['father_name']}
                                helperText={errors['father_name']}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <ChooseDate
                                input={fields.birth_date}
                                noMargin
                                color={"primary"}
                                handleDate={(val) => this.handleItem('birth_date',val)}
                                label={Translate.birth_date}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                variant="outlined"
                                size="small"
                                value={fields.phone_number}
                                fullWidth
                                label={Translate.phone_number}
                                name="phone_number"
                                onChange={this.handleChange.bind(this)}
                                error = {!!errors['phone_number']}
                                helperText={errors['phone_number']}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                variant="outlined"
                                size="small"
                                value={fields.postal_code}
                                fullWidth
                                label={Translate.postal_code}
                                name="postal_code"
                                onChange={this.handleChange.bind(this)}
                                error = {!!errors['postal_code']}
                                helperText={errors['postal_code']}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                multiline
                                minRows={2}
                                value={fields.address}
                                fullWidth
                                size="small"
                                label={Translate.address}
                                name="address"
                                onChange={this.handleChange.bind(this)}
                                error = {!!errors['address']}
                                helperText={errors['address']}
                            />
                        </Grid>
                        {
                            fields.type === "company" &&
                            <>
                            <Grid item xs={12}>
                                <SubTitleLight align="left">
                                    {Translate.companyInfo}
                                </SubTitleLight>
                            </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        variant="outlined"
                                        value={fields.company_name}
                                        fullWidth
                                        label={Translate.company_name}
                                        name="company_name"
                                        size="small"
                                        onChange={this.handleChange.bind(this)}
                                        error = {!!errors['company_name']}
                                        helperText={errors['company_name']}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        variant="outlined"
                                        value={fields.company_national_code}
                                        fullWidth
                                        label={Translate.company_national_code}
                                        name="company_national_code"
                                        onChange={this.handleChange.bind(this)}
                                        size="small"
                                        error = {!!errors['company_national_code']}
                                        helperText={errors['company_national_code']}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        variant="outlined"
                                        value={fields.company_register_number}
                                        size="small"
                                        fullWidth
                                        label={Translate.company_register_number}
                                        name="company_register_number"
                                        onChange={this.handleChange.bind(this)}
                                        error = {!!errors['company_register_number']}
                                        helperText={errors['company_register_number']}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        variant="outlined"
                                        value={fields.company_financial_number}
                                        size="small"
                                        fullWidth
                                        label={Translate.company_financial_number}
                                        name="company_financial_number"
                                        onChange={this.handleChange.bind(this)}
                                        error = {!!errors['company_financial_number']}
                                        helperText={errors['company_financial_number']}
                                    />
                                </Grid>
                            </>
                        }
                        {
                            fields.type === "person" &&
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={has_invoice}
                                            onChange={() => this.setState({has_invoice:!!has_invoice ? 0 : 1})}
                                            name="has_invoice"
                                        />
                                    }
                                    label={Translate.has_invoice}
                                />
                            </Grid>
                        }
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={contract_info_done}
                                        onChange={() => this.setState({contract_info_done:!!contract_info_done ? 0 : 1})}
                                        name="for_marketplace"
                                    />
                                }
                                label={Translate.contract_info_done}
                            />
                            </Grid>
                            <Grid item xs={12}>
                                <LoadingButton
                                    variant="contained"
                                    color="primary"
                                    onClick = {this.handleSubmit.bind(this)}
                                    loading = {SubmitLoading}
                                >
                                    {Translate.setDetails}
                                </LoadingButton>
                            </Grid>
                    </Grid>
                </React.Fragment>
            );
        }
    }
}
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user
});
export default withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(MakePerson))));